import React, { useState, useEffect } from 'react'; // Import useState
import '.././styles/ReminderBanner.css';
import infoIcon from ".././assets/info-icon.png";
import closeIcon from ".././assets/close-icon.png";

function NewDomainReminder() {  
  const [isVisible, setIsVisible] = useState();

  const handleClose = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    // Cleanup the timer if the component unmounts before 3 seconds
    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) {
    return null; // Don't render if not visible
  }

  return (
    <div className="container" id="reminder-notification">
        <div className="sub-container reminder-container">
            <img className="icon" alt="An Icon" src={infoIcon}></img>
            <p className="reminder-description">
                <b>Important: </b> 
                This is the official and most up-to-date website for <i>thenewpccm.ca</i>. 
                Any other websites such as <i>thepccm.ca</i> may contain outdated information.
            </p>
            <div className="button" onClick={handleClose}><h5>Got It!</h5></div>
        </div>
      </div>
  );
};

export default NewDomainReminder;